module.exports = __webpack_public_path__ + "static/media/instagram.edea59f1.svg";